export const GET_CURRENT_CURRENCIES = 'GET_CURRENT_CURRENCIES';


